/* This file was generated automatically. Do not edit manually. */

export enum GeneralEnterpriseSubscriptionState {
    Enabled = 'Enabled',
    Overdue = 'Overdue',
    Suspended = 'Suspended',
    Terminated = 'Terminated',
    Draft = 'Draft',
    OnHold = 'OnHold',
}
